import React, { Component } from "react";
import { Link } from "react-router-dom"; // เพิ่ม import Link
import './header.css';
import Navbar from "./navbar";

class Header extends Component {
  render() {
    return (
      <header id="header" className="header d-flex align-items-center sticky-top">
        <div className="container-fluid position-relative d-flex align-items-center justify-content-between">
          <Link to="/home" className="logo d-flex align-items-center me-auto me-xl-0">
            {/* <img
              src="bower_components/img/LOGOCooperativeTOP8.png"
              data-at2x="bower_components/img/LOGOCooperativeTOP8.png"
              style={{ height: 240 }}
              alt=""
            /> */}
          </Link>
          <Navbar />
        </div>
      </header>
    );
  }
}

export default Header;